<div>
  <wl-commodity-offer-accordion
    [offer]="currentContract()"
    [opened]="openCard()"
    [showLoadingState]="showLoadingState()"
    wlCSCapture
  >
    <ng-template #accordionHeader>
      <span class="current-contract-card-header">
        {{ currentContract()?.productTitle }}
      </span>
    </ng-template>
    <ng-template #accordionBody>
      @if (currentContract(); as currentContract) {
        <div class="current-contract-card-body">
          {{ contractBody(currentContract) }}
        </div>

        <div class="d-flex justify-content-center">
          <button
            class="btn p-0 border-0 btn-link my-2"
            (click)="viewTariffs.emit(currentContract)"
            wlAutomationId="current-card-card-button"
            wlCSCapture
            trackInteraction="click"
            interactionCategory="link"
            [interactionData]="interactionData(currentContract)"
          >
            {{ content()?.tariffModalLinkTextLabel }}
          </button>
        </div>
      }
    </ng-template>
  </wl-commodity-offer-accordion>
</div>
